var PageBackButton = function PageBackButton() {
  var navigate = useNavigate();
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--back",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      return navigate(-1);
    }
  }, "back"));
};
export default PageBackButton;